export default __webpack_public_path__ + "static/media/conventus-6.93662eb9.png";